import { pickGmwLibraryFields } from "../../../schema/gmw-schema-library";

import type { SourcedocumentDataSchemaFor } from "./_gmw-event-schema-collection";

export const gmwPositionSchema: SourcedocumentDataSchemaFor<"GMW_Positions"> = {
  type: "object",
  title: "Gebeurtenis gegevens",
  required: [
    "eventDate",
    "groundLevelStable",
    "groundLevelPosition",
    "groundLevelPositioningMethod",
    "monitoringTubes",
  ],
  properties: {
    ...pickGmwLibraryFields([
      "eventDate",
      "wellStability",
      "groundLevelStable",
      "groundLevelPosition",
      "groundLevelPositioningMethod",
    ]),
    monitoringTubes: {
      type: "array",
      title: "Monitoringsbuis",
      minItems: 1,
      items: {
        type: "object",
        required: ["tubeNumber", "tubeTopPosition", "tubeTopPositioningMethod"],
        properties: pickGmwLibraryFields([
          "tubeNumber",
          "tubeTopPosition",
          "tubeTopPositioningMethod",
        ]),
      },
    },
  },
};
